/* ============================================
   OFFGRID OPERATOR, Theme JavaScript
   OWN YOUR SIGNAL
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Mobile nav toggle ----
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('open');
      hamburger.classList.toggle('active', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      const spans = hamburger.querySelectorAll('span');
      if (isOpen) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });

    // Close nav when clicking outside
    document.addEventListener('click', function (e) {
      if (mobileNav.classList.contains('open') &&
          !mobileNav.contains(e.target) &&
          !hamburger.contains(e.target)) {
        mobileNav.classList.remove('open');
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
        const spans = hamburger.querySelectorAll('span');
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });
  }

  // ---- Product gallery thumbnails ----
  const thumbs = document.querySelectorAll('.product-gallery__thumbs img');
  const mainImg = document.querySelector('#main-product-image');
  thumbs.forEach(function (thumb) {
    thumb.style.cursor = 'pointer';
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.dataset.full || thumb.src;
        mainImg.alt = thumb.alt;
      }
    });
  });

  // ---- Quantity selector ----
  const qtyBtns = document.querySelectorAll('.qty-btn');
  qtyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.qty-selector').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'inc') { val = val + 1; }
      if (btn.dataset.action === 'dec') { val = Math.max(1, val - 1); }
      input.value = val;
    });
  });

  // ---- Option button selection ----
  const optionGroups = document.querySelectorAll('.option-buttons');
  optionGroups.forEach(function (group) {
    const btns = group.querySelectorAll('.option-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('selected'); });
        btn.classList.add('selected');
      });
    });
  });

  // ---- Add to cart loading state ----
  const atcForm = document.querySelector('form[action="/cart/add"]');
  if (atcForm) {
    const atcBtn = atcForm.querySelector('.add-to-cart-btn');
    atcForm.addEventListener('submit', function () {
      if (atcBtn && !atcBtn.disabled) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
        atcBtn.setAttribute('aria-busy', 'true');
      }
    });
  }

  // ---- Sticky header shadow via CSS class ----
  const header = document.querySelector('.site-header');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > 20);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ---- Scroll reveal (respects prefers-reduced-motion) ----
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const reveals = document.querySelectorAll('.feature-card, .product-card');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    reveals.forEach(function (el) {
      el.classList.add('will-reveal');
      observer.observe(el);
    });
  }

});
